import React from 'react'
import { Row, Col, Dropdown } from 'antd'
import { IMAGE_URL } from '@/constant/IMAGE'
import { TextArea } from '../../WelcomeCallPage/WelcomeCallInformation/styles'
import {
  LeftSection,
  PDFControls,
  PreviewContainer,
  PreviewRenderHtml,
  RenderHtmlWrapper,
  RightSection,
  SectionTitle,
  StyledLeft,
  StyledModal,
  StyledRight,
  StyledToolbar,
  TextAreaContainer,
  ZoomLevelStyled,
} from './styles'
import { DownOutlined } from '@ant-design/icons'
import useRejectClaimModal from './RejectClaimModal.hook'

function RejectClaimModal() {
  const {
    openRejectClaimModal,
    handleCancel,
    handleSubmit,
    rejectReason,
    zoomLevel,
    renderPDF,
    contentRef,
    items,
    getLabelZoom,
    openPreviewPDFModal,
    setPreviewPDFModal,
    onChangeText,
    data,
    renderFullPDF,
    setRenderFullPDF,
    contentRefPreview,
  } = useRejectClaimModal()

  return (
    <>
      <StyledModal
        title="แจ้งปฏิเสธคำขอค่าสินไหมทดแทน"
        open={openRejectClaimModal}
        onCancel={handleCancel}
        onOk={handleSubmit}
        okText="ส่ง"
        cancelText="ยกเลิก"
        width={1024}
        okButtonProps={{
          disabled: !rejectReason.trim(),
        }}
        centered
      >
        <Row>
          <Col span={8}>
            <LeftSection>
              <SectionTitle>ข้อความอธิบายการปฏิเสธ</SectionTitle>
              <TextAreaContainer>
                <TextArea
                  id="reject-reason"
                  name="rejectReason"
                  rows={16}
                  placeholder="ระบุ"
                  value={rejectReason}
                  onChange={onChangeText}
                  autoSize={{ minRows: 22, maxRows: 22 }}
                  maxLength={800}
                  data-testid="reject-reason-textarea"
                  showCount
                />
              </TextAreaContainer>
            </LeftSection>
          </Col>
          {/* ส่วนขวา - แสดง PDF */}
          <Col span={16}>
            <RightSection>
              <StyledToolbar>
                <StyledLeft>
                  <Dropdown menu={{ items }} placement="bottomLeft">
                    <ZoomLevelStyled onClick={(e) => e.preventDefault()}>
                      {getLabelZoom(zoomLevel)}
                      <DownOutlined style={{ width: 12, height: 6 }} />
                    </ZoomLevelStyled>
                  </Dropdown>
                </StyledLeft>
                <StyledRight
                  onClick={() => {
                    if (contentRefPreview.current) {
                      contentRefPreview.current.innerHTML = renderPDF || ''
                    }
                    setPreviewPDFModal(true)
                    setRenderFullPDF(renderPDF)
                  }}
                >
                  <img src={IMAGE_URL.fullViewIcon} alt="Full View" />
                </StyledRight>
              </StyledToolbar>
              <style>
                {`
                body {
                  margin: 0 !important;
                }
              `}
              </style>
              <PDFControls>
                {renderPDF ? (
                  <RenderHtmlWrapper zoom={zoomLevel}>
                    <div
                      ref={contentRef}
                      dangerouslySetInnerHTML={{ __html: renderPDF }}
                      style={{
                        maxHeight: 1103,
                      }}
                    />
                  </RenderHtmlWrapper>
                ) : null}
              </PDFControls>
            </RightSection>
          </Col>
        </Row>
      </StyledModal>
      <PreviewContainer
        centered
        open={openPreviewPDFModal}
        closeIcon={null}
        closable={false}
        footer={null}
        onOk={() => {
          if (contentRefPreview.current) {
            contentRefPreview.current.innerHTML = data.html || ''
          }
          setPreviewPDFModal(false)
          setRenderFullPDF('')
        }}
        onCancel={() => {
          if (contentRefPreview.current) {
            contentRefPreview.current.innerHTML = data.html || ''
          }
          setRenderFullPDF('')
          setPreviewPDFModal(false)
        }}
      >
        {renderFullPDF ? (
          <PreviewRenderHtml>
            <div
              key={renderFullPDF}
              ref={contentRefPreview}
              dangerouslySetInnerHTML={{ __html: renderFullPDF || '' }}
              style={{
                maxHeight: 1103,
                width: 864,
                margin: '0 auto',
              }}
            />
          </PreviewRenderHtml>
        ) : null}
      </PreviewContainer>
    </>
  )
}

export default RejectClaimModal
